<template>
    <div class="rules">
        <div class="rules-container">
            <div class="back_option" @click="backRoute()">
                <img src="/img/icons/back.png" alt="">
                <span>{{$t("components.Rules.backOption")}}</span>
            </div>
            <div class="title-rules">
                <!-- <h1 class="title" v-show="!video_rules">
                    Relembrando algumas 
                </h1> -->
                <span class="regras">{{$t("components.Rules.title")}}</span>
            </div>
            <div class="video_rules" v-show="video_rules">
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/vKkgE-_f0RU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="text-rules" v-show="!video_rules">
                <div class="rule">
                    <p>{{$t("components.Rules.rules[0]")}}</p>
                    <span><strong>{{$t("components.Rules.rules[1]")}}</strong>{{$t("components.Rules.rules[2]")}}<strong>{{$t("components.Rules.rules[3]")}}</strong>{{$t("components.Rules.rules[4]")}}</span>
                </div>
                <ul>
                    <li>{{$t("components.Rules.rules[5]")}}<strong>{{$t("components.Rules.rules[6]")}}</strong></li>
                    <li>{{$t("components.Rules.rules[7]")}}<strong>{{$t("components.Rules.rules[8]")}}</strong></li>
                    <li>{{$t("components.Rules.rules[9]")}}<strong>{{$t("components.Rules.rules[10]")}}</strong>{{$t("components.Rules.rules[11]")}}<strong>{{$t("components.Rules.rules[12]")}}</strong>{{$t("components.Rules.rules[13]")}}<strong>{{$t("components.Rules.rules[14]")}}</strong></li>
                    <li><strong>{{$t("components.Rules.rules[15]")}}</strong>{{$t("components.Rules.rules[16]")}}</li>
                    <li>{{$t("components.Rules.rules[17]")}}<strong>{{$t("components.Rules.rules[18]")}}</strong>, <strong>{{$t("components.Rules.rules[19]")}}</strong>{{$t("components.Rules.rules[20]")}}<strong>{{$t("components.Rules.rules[21]")}}</strong>;</li>
                </ul>
            </div>
            <div class="acceptance_button" @touch="next()" @click="next()" 
                 :class="!formedGroup && !video_rules ? 'notFormed' : ''">
                <span>{{button_text}}</span>
                <div class="arrow-right"></div>
            </div>
        </div>
    </div>
</template>
<script> import firebase from '../../firebase/firebase.js'
export default {
    data: ()=>({
        checked: false,
        video_rules: true,
        video_height: '',
        button_text: this.$t("components.Rules.buttonText[0]"),
        isBtnDisabled: true,
    }),
    props:{
        formedGroup : {

        }
    },
    created(){
        var self = this
        self.video_height = window.outerHeight / 2
        self.isBtnDisabled = false
    },
    methods:{
        next(){
            if(this.video_rules){
                if(!this.isBtnDisabled){
                    this.video_rules = !this.video_rules
                    if(!this.formedGroup){
                        this.button_text = this.$t("components.Rules.buttonText[1]")
                        return
                    }
                    this.button_text = this.$t("components.Rules.buttonText[2]")
                }
                return
            }
            if(!this.formedGroup){
                this.video_rules = !this.video_rules
                return 
            }
            this.$router.push('/chat-initial')
        },
        backRoute(){
            this.$router.push('/waiting-room')
        }
    }
}
</script>
<style lang="scss" scoped>
    .rules{

        height: calc(100vh - 65px);

        .rules-container{

            height: 100%;
            display: flex;
            flex-direction: column;
            position: relative;

            .back_option{
                display: flex;
                align-items: center;
                padding: 15px 15px 0;

                img{
                    max-width: 32px;
                    margin-right: 10px;
                }
                span{
                    text-transform: uppercase;
                    font-size: 13px;
                    font-weight: 700;
                    letter-spacing: 2px;
                }
            }

            .title-rules{

                height: 15%;
                display: flex;  
                align-items: center;
                justify-content: center;
                flex-direction: column;

                .title, .regras{

                    text-transform: uppercase;
                    font-weight: bold;
                    letter-spacing: 3px;
                }

                .title{

                    font-size: 14px;
                    color: #939393;
                }

                .regras{

                    color : #616E77;
                    font-size: 35px;
                    margin-top: 5px;
                }
            }

            .text-rules{

                height: calc(100% + 120px);
                display: flex;
                flex-direction: column;
                margin-top: 5%;

                ul{
                    padding-left: 32px;
                    color : #616E77;
                    li{
                        list-style-type: disc;
                        padding: 5px;
                        font-size: 14px;

                        strong{
                            font-weight: 700
                        }
                    }
                }
                .rule{

                    width: 85%;
                    margin: 0 auto 40px;
                    color: #666666;
                    font-size: 18px;
                    text-align: center;
                    font-weight: 700;


                    span{

                        font-size: 15px;
                    }

                }
            }

            .button-play{

                position: fixed;
                bottom: 0;
                width: 100%;
            }
            .acceptance_button{
                position: fixed;
                display: flex;
                align-items: center;
                text-align: center;
                height: 10vh;
                color: #000;
                font-weight: 700;
                text-decoration: none;
                background-color: #FFF581;
                // position: absolute;
                width: 100%;
                bottom: 0;
                transition: background .5s, color .5s, opacity .7s;


                span{
                    font-size: 15px;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    width: 90%
                }

                .arrow-right{
                    width: 0;
                    height: 0;
                    border-top: 6px solid transparent;
                    border-bottom: 6px solid transparent;
                    border-left: 6px solid #000;
                    width: 10%;
                }
            }
            .notFormed{

                span{
                    order: 2
                }

                .arrow-right{
                    order: 1;
                    border-right: 6px solid #000;
                    border-left: none;
                    margin-left: 10px;
                    width: 0%;
                }
            }

            .acceptance_button.disabled{
                opacity: .2;
                background: #2f353a94;
                color: #fff;
            }

        }
    }

    @media only screen and (min-width: 600px){
        .rules{

            .rules-container{

                .title-rules{

                    .title{

                        font-size: 19px;
                    }

                    .regras{

                        font-size: 55px;
                    }
                }

                .text-rules{

                    .rule{

                        font-size: 20px;
                    }
                }

                .button-play{

                    height: 10%;
                    position: inherit;
                }
            }
        }
    }
</style>
